import React, { Component } from "react";
import { Player, BigPlayButton } from 'video-react';
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Image from '../global/Image';

export default class PageVideo extends Component {
    
	render () {
		
		let block 	= this.props.block;
		
		if (block) {
	        	        
		    return (
		        <div id={block.id} className={'c-page__block c-page__block--charcoal c-page__block--transparent'}>
		        	
		        	<div className={'c-video'}>
		        	
		        		<div className="c-video__inner">
				    					
				        	<div className="c-video__video c-load-fade">
								<Player width='100%' height='100%' poster={block.src} playsInline={true} src={block.full_video}>
									<BigPlayButton position="center" />
								</Player>
							</div>							
						</div>
				        
					</div>
			        
				</div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
